(function(w,d){
  'use strict';
  var params=new URLSearchParams(w.location.search);
  if(params.get('jps_setup')!=='1')return;
  var raw=params.get('jps_gpm')||'',gpm=Number(raw),connection=(params.get('jps_connection')||'').replace(/\"$/,' inch');
  var validFlow=/^\d+(?:\.\d+)?$/.test(raw)&&gpm>0&&gpm<=200;
  var validConnection=['1/4 inch','3/8 inch','1/2 inch','5/8 inch','3/4 inch','1 inch','1-1/4 inch'].indexOf(connection)>=0;
  if(!validFlow&&!validConnection)return;
  var setup={jps_setup:'1'};
  if(validFlow)setup.jps_gpm=String(gpm);
  if(validConnection)setup.jps_connection=connection;
  if(params.get('jps_qa')==='1')setup.jps_qa='1';
  var preview=params.get('preview_theme_id');
  if(preview&&/^\d+$/.test(preview))setup.preview_theme_id=preview;
  function destination(href){
    try{
      var url=new URL(href,w.location.origin);
      if(url.origin!==w.location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(url.pathname))return null;
      Object.keys(setup).forEach(function(key){url.searchParams.set(key,setup[key]);});
      return url.pathname+url.search+url.hash;
    }catch(error){return null;}
  }
  function apply(){
    var grid=d.getElementById('pgrid');if(!grid)return;
    var main=d.querySelector('main')||d.querySelector('.jps-phase2-collection')||grid;
    main.querySelectorAll('a[href]').forEach(function(link){var url=destination(link.getAttribute('href'));if(url)link.setAttribute('href',url);});
    grid.querySelectorAll('.pcard').forEach(function(card){
      var url=destination(card.getAttribute('data-product-url'));if(url)card.setAttribute('data-product-url',url);
    });
    var source=d.getElementById('jpsCollectionHandoffCopy'),copy;
    try{copy=source&&JSON.parse(source.textContent);}catch(error){}
    if(copy&&!d.getElementById('jpsCollectionSetup')){
      var note=d.createElement('p');note.id='jpsCollectionSetup';note.setAttribute('role','status');
      note.textContent=copy.prefix+' '+[validFlow?String(gpm)+' GPM':'',validConnection?connection+' '+copy.connection:''].filter(Boolean).join(' · ')+'. '+copy.review;
      note.style.cssText='padding:12px 16px;margin:0 0 16px;background:#edf6ff;color:#16324a;border:1px solid #cbdce8;border-radius:6px;font-size:14px;line-height:1.5';
      grid.parentNode.insertBefore(note,grid);
    }
  }
  d.addEventListener('jps:collection-ready',apply);
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',apply);else apply();
})(window,document);
